import { db, auth } from "../../services/firebase";
import {
  collection,
  addDoc,
  Timestamp
} from "firebase/firestore";    

export async function submitContactMessageClient({
    fullName,
    email,
    subject,
    message,
    source = "contact_page",
}) {

    if (!fullName?.trim()) {
        throw new Error("Full name is required");
    }

    if (!email?.trim()) {
        throw new Error("Email is required");
    }

    if (!subject?.trim()) {
        throw new Error("Subject is required");
    }

    if (!message?.trim()) {
        throw new Error("Message is required");
    }

    const user = auth.currentUser;

    await addDoc(collection(db, 'contactMessages'), {
    fullName: fullName.trim(),
    email: email.trim().toLowerCase(),
    subject: subject.trim(),
    message: message.trim(),
    source,

    userId: user?.uid || null,
    userEmail: user?.email || null,

    status: "unread",
    submittedAt: Timestamp.now(),
    });    
}




